import { render } from "./CoursesUser.vue?vue&type=template&id=9cbd7040"
import script from "./CoursesUser.vue?vue&type=script&lang=js"
export * from "./CoursesUser.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-plataforma-ead\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__